<template>
  <v-toolbar-items class="hidden-xs-only">
    <v-menu open-on-hover bottom offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-btn text v-on="on" v-bind="attrs" to="/people" @click="setUserAsSelected">
          <img :src="user.photoURL" class="toolbar-title-img ma-3" alt="user photo">
          <v-list-item-title class="primary--text user-name">{{user.displayName}}</v-list-item-title>
          <v-icon class="primary--text">keyboard_arrow_down</v-icon> 
        </v-btn>
      </template>
      <v-list>
        <v-list-item
          v-for="(item, index) in vertItems"
          :key="index"
          @click="signout"
        >
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-toolbar-items>
</template>

<script>
import { signout } from "../vue-service-auth";
import { setUserAsSelectedPerson } from "@/vue-service-selected_person";

export default {
  name: "navitems",
  methods: {
    signout,
    setUserAsSelected() {;
      setUserAsSelectedPerson(this.user);
    }
  },
  data: () => {
    return {
      vertItems: [{ title: "Logout" }]
    };
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
  }
};
</script>
<style scoped>
.user-name{
  text-transform: capitalize;
  font-size: 16px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/NavItems.vue